<button
  #modalConfirmButton
  id="modalConfirmButton"
  aria-label="Modal Confirm Button"
  data-test="modalConfirmButton"
  (click)="action()"
  class="exportConfirmButton"
  [class.modalConfirmButton--secondary]="ppStyle === 'secondary'"
  [class.modalConfirmButton--disabled]="ppDisabled"
  [class.modalConfirmButton--error]="ppError"
>
  <pp-spinner [ppButton]="false" [ppLight]="true" [ppHidden]="!ppProcess"></pp-spinner>

  <span class="button__text" [class.button__text--hidden]="ppProcess">
    <ng-content></ng-content>
  </span>
</button>
